import { FashionProduct, ProductVariant } from './types';

// ... (previous products)

// Products defined below

export const PRODUCTS: FashionProduct[] = [
  // MAN
  {
    id: 'obsidian-tee',
    name: "Obsidian Heavyweight Tee",
    category: 'Tops',
    gender: 'Man',
    tagline: "Structure & Void",
    description: "A 280gsm heavyweight cotton t-shirt with a boxy fit and drop shoulders. Garment dyed in deep obsidian.",
    price: "$120",
    color: "#1C1C1C",
    materials: ["100% Cotton", "Pre-shrunk", "Garment Dyed"],
    image: "https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },
  {
    id: 'slate-cargo',
    name: "Tactical Slate Cargo",
    category: 'Bottoms',
    gender: 'Man',
    tagline: "Utility Evolved",
    description: "Technical nylon blend cargos with articulated knees and magnetic closure pockets.",
    price: "$280",
    color: "#64748B",
    materials: ["Nylon Blend", "Water Resistant", "YKK Zippers"],
    image: "https://images.unsplash.com/photo-1473966968600-fa801b869a1a?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },
  {
    id: 'nebula-jacket',
    name: "Nebula Shell Jacket",
    category: 'Outerwear',
    gender: 'Unisex',
    tagline: "Atmospheric Protection",
    description: "3-layer waterproof shell with taped seams and an iridescent finish.",
    price: "$450",
    color: "#0F172A",
    materials: ["Gore-Tex", "Waterproof", "Windproof"],
    image: "https://images.unsplash.com/photo-1591047139829-d91aecb6caea?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },
  {
    id: 'kinetic-runners',
    name: "Kinetic Runners",
    category: 'Footwear',
    gender: 'Unisex',
    tagline: "Forward Motion",
    description: "Sculpted foam sole with a knit upper for sock-like fit and energy return.",
    price: "$320",
    color: "#F8FAFC",
    materials: ["Knit Blend", "EVA Foam", "Rubber"],
    image: "https://images.unsplash.com/photo-1600185365483-26d7a4cc7519?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },
  {
    id: 'void-tote',
    name: "Void Tote Bag",
    category: 'Accessories',
    gender: 'Unisex',
    tagline: "Carry Everything",
    description: "Oversized canvas tote with structured leather handles and minimal branding.",
    price: "$180",
    color: "#D4D4D8",
    materials: ["Heavy Canvas", "Leather Trim"],
    image: "https://images.unsplash.com/photo-1544816155-12df9643f363?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },
  {
    id: 'classic-elegant-men',
    name: "Classic Elegant",
    category: 'Outerwear',
    gender: 'Man',
    tagline: "Timeless Tailoring",
    description: "A tailored formal jacket combining modern sharp lines with classic materials.",
    price: "$350",
    color: "#2C2C2C",
    materials: ["Wool Blend", "Satin Lapel"],
    image: "https://images.unsplash.com/photo-1594938298603-c8148c4dae35?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },

  // WOMAN
  {
    id: 'structure-trench',
    name: "Classic Trench Coat",
    category: 'Outerwear',
    gender: 'Woman',
    tagline: "Timeless Layer",
    description: "Oversized cotton gabardine trench coat with storm flap and belted waist.",
    price: "$390",
    color: "#C2B280",
    materials: ["Cotton Gabardine", "Water Repellent"],
    image: "https://images.unsplash.com/photo-1564584217132-2271feaeb3c5?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },
  {
    id: 'structured-blazer',
    name: "Architectural Blazer",
    category: 'Outerwear',
    gender: 'Woman',
    tagline: "Power Silhouette",
    description: "Oversized wool blazer with exaggerated shoulders and nipped waist.",
    price: "$420",
    color: "#18181B",
    materials: ["Virgin Wool", "Silk Lining"],
    image: "https://images.unsplash.com/photo-1552374196-1ab2a1c593e8?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },
  {
    id: 'pleated-skirt',
    name: "Asymmetric Pleat Skirt",
    category: 'Bottoms',
    gender: 'Woman',
    tagline: "Dynamic Movement",
    description: "Sun-ray pleated midi skirt with an asymmetric hemline.",
    price: "$240",
    color: "#94A3B8",
    materials: ["Polyester Blend", "Permanent Pleat"],
    image: "https://images.unsplash.com/photo-1551163943-3f6a29e3945a?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },
  {
    id: 'evening-wear-women',
    name: "Evening Wear",
    category: 'Tops',
    gender: 'Woman',
    tagline: "Midnight Elegance",
    description: "A flowing, dramatic evening top designed to catch the light.",
    price: "$290",
    color: "#18181B",
    materials: ["Silk", "Chiffon"],
    image: "https://images.unsplash.com/photo-1629737168222-baad8ecacebe?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },

  // KIDS
  {
    id: 'mini-bomber',
    name: "Mini Aviator Bomber",
    category: 'Outerwear',
    gender: 'Kids',
    tagline: "Little Pilot",
    description: "Classic nylon bomber jacket scaled down for the next generation.",
    price: "$110",
    color: "#475569",
    materials: ["Nylon", "Cotton Ribbing"],
    image: "https://images.unsplash.com/photo-1621452773781-0f992fd1f5cb?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },
  {
    id: 'essential-hoodie-kids',
    name: "Cloud Soft Hoodie",
    category: 'Tops',
    gender: 'Kids',
    tagline: "Play All Day",
    description: "Ultra-soft organic cotton hoodie with reinforced stitching.",
    price: "$65",
    color: "#F1F5F9",
    materials: ["Organic Cotton", "Fleece Lined"],
    image: "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },
  {
    id: 'denim-overalls-kids',
    name: "Utility Overalls",
    category: 'Bottoms',
    gender: 'Kids',
    tagline: "Ready for Adventure",
    description: "Durable denim overalls with adjustable straps and plenty of pockets.",
    price: "$85",
    color: "#334155",
    materials: ["Denim", "Brass Hardware"],
    image: "https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  },
  {
    id: 'party-time-kids',
    name: "Party Time",
    category: 'Tops',
    gender: 'Kids',
    tagline: "Celebrate & Play",
    description: "A fun and brightly colored outfit setup designed to pop during celebrations.",
    price: "$60",
    color: "#FCD34D",
    materials: ["Soft Cotton", "Elastane"],
    image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?auto=format&fit=crop&q=80&w=800",
    videoBackground: "",
  }
];

export const COLORS = {
  brandPrimary: '#D97B8D', // Still keeping for now as requested accent
  brandLight: '#F2DCE0',
  deepBasil: '#1C1C1C',
  creamVanilla: '#FDFCFB',
};